import {AfterViewInit, Component, OnInit} from "@angular/core";
import {ServiceSet} from "../models/service-set";
import {Service} from "../models/service";
import {Preferences} from "common-angular-module";
import {StartECaseService} from "../start-ecase-service";
import minBy from "lodash/minBy";

declare var $: any;

@Component({
  selector: 'app-start-ecase',
  templateUrl: './start-ecase.component.html',
  styleUrls: ['./start-ecase.component.css']
})
export class StartECaseComponent implements OnInit, AfterViewInit {

  serviceSets: ServiceSet[] = [];
  activeServiceSet: ServiceSet = new ServiceSet();
  typeView: string = '';
  onlyResults: boolean = false;
  sortServicesAlphabetically: boolean = false;
  sortServiceSetsManually: boolean = false;
  preferences: Preferences;
  startECaseService: StartECaseService;
  startECaseURL: string;
  servicesWithECaseSetAsURL: string;
  isSignedIn: boolean = document['angular2Portlet'].isSignedIn;
  backgroundStartECase: boolean = false;
  backgroundStartECaseURL: string;
  filterByAccountGroup: boolean = false;
  serviceSetSortBy: string = '';
  serviceSortBy: string = 'nextId';
  searchText: string = "";
  originalSet: string;

  constructor(startECaseService: StartECaseService) {
    this.startECaseService = startECaseService;
  }

  selectActiveSet(set: ServiceSet) {
    this.searchText = '';

    this.activeServiceSet.active = false;
    this.activeServiceSet = set;
    this.activeServiceSet.active = true;
  }

  toggleSection(i: string) {
    let section = $(".section-" + i);
    section.is(":visible") ? section.slideUp() : section.slideDown();
    this.serviceSets[i].active ? this.serviceSets[i].active = false : this.serviceSets[i].active = true;
  }

  activateSection(idx: string) {
    let section = $(".section-" + idx);
    if (section.is(":visible")) {
      this.serviceSets[idx].active = false;
      section.slideUp();
    } else {
      for (let i = 0; i < this.serviceSets.length; i++) {
        if (section.is(":visible")) {
          $(".section-" + i).slideUp();
          this.serviceSets[i].active = false;
          break;
        }
      }
      this.serviceSets[idx].active = true;
      section.slideDown();
    }
  }

  doStartECase(serviceId: number) {
    this.startECaseService.startECase(serviceId).subscribe(eCase => {
      if (this.preferences['waitActionStatus']) {
        this.checkActionStatus(eCase.id);
      }else if (this.preferences['waitHandlerActionStatus']) {
        this.checkHandlerActionStatus(eCase.id);
      } else {
        window.location.href = this.preferences['orbeonProxyURL'].replace('${eCaseId}', eCase.id);
      }
    });
  }

  startECase(service: Service, event?: any) {
    if (event && !(event.code == "Enter" || event.keyCode == 13)) {
      return
    }

    $(".modal-overlay").show();
    if(typeof service.externalUrl!='undefined' && service.externalUrl)
      window.location.href = service.externalUrl;
    else if (this.preferences['delegateECaseCreation']) {
      window.location.href = this.preferences['startECaseURL'] + service.friendlyUrlName;
    } else if (this.isSignedIn) {
      this.doStartECase(service.id);
    } else {
      window.location.href = this.backgroundStartECaseURL + "?serviceId=" + service.id;
    }
  }

  startECaseFromRedirect() {
    let urlParams = new URLSearchParams(window.location.search);
    let serviceId = JSON.parse(urlParams.get('serviceId'));
    if (serviceId !== null) {
      $(".modal-overlay").show();
      this.doStartECase(serviceId);
    }
  }

  checkActionStatus(eCaseId: number) {
    this.startECaseService.checkActionStatus(eCaseId).subscribe(action => {
      if (action.type !== 'CLIENT') {
        let self = this;
        setTimeout(function () {
          self.checkActionStatus(eCaseId);
        }, 1000);
      } else {
        window.location.href = this.preferences['orbeonProxyURL'].replace('${eCaseId}', eCaseId);
      }
    });
  }

  checkHandlerActionStatus(eCaseId: number) {
    this.startECaseService.checkActionStatus(eCaseId).subscribe(action => {
      if (action.type !== 'HANDLER') {
        let self = this;
        setTimeout(function () {
          self.checkActionStatus(eCaseId);
        }, 1000);
      } else {
        window.location.href = this.preferences['orbeonProxyURL'].replace('${eCaseId}', eCaseId).replace('${actionId}', action.id);
      }
    });
  }

  noServices() {
    return this.serviceSets.every(n => n.services.length === 0);
  }

  onChange(value) {
    if (value.length > 0) {
      this.originalSet = this.activeServiceSet.name;
      this.serviceSets.find(set => set.name === this.originalSet).active = false;

      let tempServiceSet = Object.assign([], this.activeServiceSet);

      let allServices = [];
      for (let i = 0; i < this.serviceSets.length; i++) {
        for (let i2 = 0; i2 < this.serviceSets[i].services.length; i2++) {
          allServices.push(this.serviceSets[i].services[i2]);
        }
      }

      allServices = allServices.filter( service => service.name.toLowerCase().includes(value.toLowerCase()));

      tempServiceSet.services = allServices;
      this.activeServiceSet = tempServiceSet;
      this.searchText = value;
    }
    else{
      if(this.originalSet.length > 0){
        this.activeServiceSet = this.serviceSets.find(set => set.name === this.originalSet);
        this.activeServiceSet.active = true;
      }
    }
  }

  ngOnInit() {
    this.preferences = document['preferences'];
    this.typeView = this.preferences['typeView'];
    this.onlyResults = this.preferences['onlyResults'];
    this.sortServicesAlphabetically = this.preferences['sortServicesAlphabetically'];
    this.sortServiceSetsManually = this.preferences['sortServiceSetsManually'];
    this.startECaseURL = this.preferences['startECaseURL'];
    this.servicesWithECaseSetAsURL = this.preferences['servicesWithECaseSetAsURL'];
    this.backgroundStartECase = this.preferences['backgroundStartECase'];
    this.backgroundStartECaseURL = this.preferences['backgroundStartECaseURL'];
    this.filterByAccountGroup = this.preferences["filterByAccountGroup"] !== undefined ? this.preferences['filterByAccountGroup'] : false;
    this.serviceSortBy = this.sortServicesAlphabetically ? 'name' : 'nextId';

    /* If typeView was not set yet, sets default typeView value */
    if (!this.typeView) {
      this.typeView = this.preferences["listView"] ? 'list' : 'tabs';
    }

    if (!this.backgroundStartECase) {
      const setIds = this.preferences['setIds'];
      const order = this.preferences["serviceSetsSortOrder"];
      if (setIds.length === 0) {
        this.startECaseService.findAll().subscribe(serviceSets => {
          this.serviceSets = serviceSets;
          this.setActiveServiceSet(order, this.serviceSets);
          this.trimServiceSetNames();
        });
      } else {
        this.startECaseService.findByServiceSetIds(setIds, this.filterByAccountGroup).subscribe(serviceSets => {
          this.serviceSets = serviceSets;
          if (this.preferences['showEmptyServicesets'] === false) {
            this.serviceSets = this.serviceSets.filter(
                set => set.services.length !== 0);
          }
          this.setActiveServiceSet(order, this.serviceSets);
          if (this.typeView === 'list') {
            for (let i = 0; i < this.serviceSets.length; i++) {
              this.serviceSets[i].active = true;
            }
          }
          this.trimServiceSetNames();
        });
      }
    } else {
      this.startECaseFromRedirect();
    }
  }

  private setActiveServiceSet(sortedServiceSetNames: string[], serviceSets: ServiceSet[]): void {
    let activeIndex = 0;
    const findActiveIndex = this.sortServiceSetsManually && (sortedServiceSetNames ? sortedServiceSetNames.length > 0 : false);
    if (findActiveIndex) {
      serviceSets.forEach(ss => ss.index = sortedServiceSetNames.findIndex(o => o === ss.name));
      this.serviceSetSortBy = 'index';
      const firstService = minBy(serviceSets, 'index');
      activeIndex = serviceSets.findIndex(ss => ss.index === firstService.index);
      activeIndex = activeIndex !== -1 ? activeIndex : 0;
    }
    this.activeServiceSet = this.serviceSets[activeIndex];
    this.activeServiceSet.active = true;
    this.serviceSets[activeIndex].active = true;
  }

  private trimServiceSetNames() {
    // get rid of the part 'XY :: ' in serviceSetNames of following type 'XY :: serviceX'
    for (let i = 0; i < this.serviceSets.length; i++) {
      let name = this.serviceSets[i].name;
      this.serviceSets[i].fullName = name;
      if  (name.includes("::")) {
        let trimmedName = name.split("::")[1].trim();
        this.serviceSets[i].name = trimmedName;
      }
    }
  }

  ngAfterViewInit() {
    for (let i = 1; i < this.serviceSets.length; i++) {
      $(".section-" + i).hide();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/start-ecase/start-ecase.component.ts